module.exports = __webpack_public_path__ + "img/Slide35.d49dcda7.png";